import React from "react";
import { Drawer, Form, Input, Select, DatePicker, Button } from "antd";
import moment from "moment";

const { Option } = Select;
const { TextArea } = Input;


function CreateMyTask({ open, onClose, onFinish, form}){
    return(
        <Drawer
      title="Add New Task"
      width={480}
      onClose={onClose}
      open={open}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          name="task"
          label="Task Title"
          rules={[{ required: true, message: "Please enter task title" }]}
        >
          <Input placeholder="Enter task name" />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <TextArea rows={3} />
        </Form.Item>

        <Form.Item
          name="priority"
          label="Priority"
          rules={[{ required: true, message: "Please select priority" }]}
        >
          <Select>
            <Option value="Low">Low</Option>
            <Option value="Normal">Normal</Option>
            <Option value="High">High</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select>
            <Option value="To Do">To Do</Option>
            <Option value="In Progress">In Progress</Option>
            <Option value="On Hold">  On Hold</Option>
          </Select>
        </Form.Item>


        <Form.Item
          name="dueDate"
          label="Due Date"
          rules={[{ required: true, message: "Please select due date" }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="urgency"
          label="Urgency"
          rules={[{ required: true, message: "Please select urgency" }]}
        >
          <Select>
            <Option value="Low">Low</Option>
            <Option value="Normal">Normal</Option>
            <Option value="High">High</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            Create Task
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CreateMyTask